module.exports = __webpack_public_path__ + "static/media/screenshot-8.f8d46d69.png";